// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"5dfd65af","597":"9690929d","837":"8781f3ce","970":"1c4f3e51"}[chunkId] + ".chunk.js";
};